import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, ListItemText } from "@material-ui/core";

const useStyles = makeStyles({
  linkText: {
    textDecoration: "none",
    textTransform: "uppercase",
    color: "#504538",
    "&:hover": {
      color: "#504538",
      fontWeight: "bold",
    },
  },
  linkButton: {
    borderRadius: "100px",
    fontWeight: "bold",
    backgroundColor: "#ffc26c",
    color: "#504538",
  },
});

const MenuButton = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();

  return (
    <Link to={"/" + props.meta.target} className={classes.linkText}>
      <ListItem button>
        {!props.meta.highlight && (
          <ListItemText primary={localize(props.meta.name, language)} />
        )}
        {props.meta.highlight && (
          <Button variant="contained" className={classes.linkButton}>
            {localize(props.meta.name, language)}
          </Button>
        )}
      </ListItem>
    </Link>
  );
};

export default MenuButton;
